import { Platform } from 'react-native';

import Share from 'react-native-share';

import Axios from 'axios';

type ItunesLookupResponse = {
    resultCount: number;
    results: {
        bundleId: string;
    }[];
};

export default async function getAppName(
    androidMobileBundleId: string,
    appleAppId: string,
) {
    try {
        if (Platform.OS === 'ios') {
            const { data } = await Axios.get<ItunesLookupResponse>(
                `http://itunes.apple.com/lookup?id=${appleAppId}`,
            );

            const { resultCount, results } = data;

            if (resultCount > 0) {
                return results[0].bundleId;
            }

            return '';
        }

        const appNameResult = await Share.getApplicationName(
            androidMobileBundleId,
        );

        return appNameResult.appName ?? '';
    } catch {
        return '';
    }
}
